/** Persists only the selected mailbox hash (opaque id), not names or full list. */
const STORAGE_KEY = "flipmail-mailbox-hash";

export function getStoredMailboxHash() {
  try {
    return localStorage.getItem(STORAGE_KEY) || "";
  } catch {
    return "";
  }
}

export function persistMailboxHash(hash) {
  try {
    if (hash) {
      localStorage.setItem(STORAGE_KEY, hash);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* ignore quota / private mode */
  }
}
